import { useEffect } from "react";
import PropTypes from "prop-types";
import { showToast } from "../../utils/utils";
import {
  DELTA,
  FMFB_FR,
  FMFB_TO_FR,
  FR_FMFB,
  FR_TO_FMFB,
  showToastType,
  STATUS
} from "../../utils/constants/appConstants";
import {
  getFmfbtoFrUrl,
  getMigrationStatusUrl
} from "../../utils/constants/apiEndPoints";
import { migrationAxios } from "../../utils/axiosPrivate";

const MigrationAction = ({ action, onComplete }) => {
  useEffect(() => {
    const callMigrationApi = async () => {
      if (action === FMFB_TO_FR) {
        try {
          const response = await migrationAxios.post(getFmfbtoFrUrl, {
            project_name: FMFB_FR,
            file_name: DELTA
          });
          showToast(response?.data?.message, showToastType?.success);
        } catch (error) {
          showToast(
            error?.response?.data?.message || showToastType?.errorText,
            showToastType?.error
          );
        } finally {
          onComplete();
        }
      } else if (action === FR_TO_FMFB) {
        try {
          const response = await migrationAxios.post(getFmfbtoFrUrl, {
            project_name: FR_FMFB,
            file_name: DELTA
          });
          showToast(response?.data?.message, showToastType?.success);
        } catch (error) {
          showToast(
            error?.response?.data?.message || showToastType?.errorText,
            showToastType?.error
          );
        } finally {
          onComplete();
        }
      } else if (action === STATUS) {
        try {
          const response = await migrationAxios.get(getMigrationStatusUrl);
          showToast(response?.data?.message, showToastType?.success);
        } catch (error) {
          showToast(
            error?.response?.data?.message || showToastType?.errorText,
            showToastType?.error
          );
        } finally {
          onComplete();
        }
      }
    };

    callMigrationApi();
  }, [action, onComplete]);

  return null;
};

MigrationAction.propTypes = {
  action: PropTypes.oneOf([FMFB_TO_FR, FR_TO_FMFB, STATUS]).isRequired,
  onComplete: PropTypes.func.isRequired
};

export default MigrationAction;
